import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'portion.bg';
const BASE_URL = 'https://portion.bg';
const OG_IMAGE = 'https://customer-assets.emergentagent.com/job_a11b58b7-0755-420a-a187-4df463e6d440/artifacts/e43armik_Screenshot%202026-06-27%20at%2018.17.46.png';
const OG_IMAGE_WIDTH = 1200;
const OG_IMAGE_HEIGHT = 630;

export const SEOMeta = ({
  title,
  description,
  keywords,
  canonical,
  noindex = false,
  breadcrumbs = null,
  schemas = [],
}) => {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `Portion — Персонален хранителен план по калории | ${SITE_NAME}`;
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

  const breadcrumbSchema = breadcrumbs
    ? {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [{ label: 'Начало', href: '/' }, ...breadcrumbs].map((crumb, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: crumb.label,
          item: `${BASE_URL}${crumb.href}`,
        })),
      }
    : null;

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${canonicalUrl}#webpage`,
    url: canonicalUrl,
    name: fullTitle,
    description: description || '',
    inLanguage: 'bg-BG',
    isPartOf: { '@id': `${BASE_URL}/#website` },
  };

  return (
    <Helmet>
      <html lang="bg" />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content={String(OG_IMAGE_WIDTH)} />
      <meta property="og:image:height" content={String(OG_IMAGE_HEIGHT)} />
      <meta property="og:image:alt" content="portion.bg — персонален AI хранителен план" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="bg_BG" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content="portion.bg — персонален AI хранителен план" />

      {/* WebPage structured data */}
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>

      {/* Breadcrumb structured data */}
      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}

      {/* Custom page schemas */}
      {schemas.map((schema, i) => (
        <script key={`schema-${i}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};
